import { integration } from '@yola/ws-sdk';
import documentKeydownHandler from '../helpers/document-keydown-handler';

const registerHotkeys = () => {
  window.addEventListener('message', integration.handlers.keyEventMessageHandler, false);
  window.addEventListener('keydown', documentKeydownHandler, false);
};

export default registerHotkeys;
